module.exports = __webpack_public_path__ + "img/2-3.ab1d891b.svg";